export const WALLET_DATA = "WALLET_DATA";
export const SETTINGS_DATA = "SETTINGS_DATA";
export const LIQ_DATA = "LIQ_DATA";
export const COMMON_WALLET_DATA = "COMMON_WALLET_DATA";
export const TOKEN_DETAIL = "TOKEN_DETAIL";



